export enum StackDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum StackSpacing {
  MD = 'md',
  SM = 'sm',
}
